import { navigateRoute, setIsOverlayLogin, useAppDispatch } from "@next-platform/client-common-core";
import { useCallback } from "react";

import { ROUTES } from "@/constants";

/**
 * Opens the sign in overlay for a guest on a page that has nothing to show them. Closing the overlay
 * without signing in sends them Home, and that rule lives here for every surface that opens it this way.
 */
export default function useOpenGuestSignIn(): () => void {
  const dispatch = useAppDispatch();
  return useCallback(() => {
    dispatch(navigateRoute(ROUTES.home));
    dispatch(setIsOverlayLogin(true));
  }, [dispatch]);
}
